<template>
  <div v-if="!loaded" v-html="info" :style="infoStyle" />
  <div v-else-if="formData.layout === layouts.list">
    <div v-for="cp in commProductList" :key="cp.key" :id="cp.key" style="border:solid; text-align: left;">
      <comm-product
        :contentKey="cp.key"
        :cmptData="cp"
        addBtnConfetti
        @comm-product-details="handleDetails($event)" />
        <!-- @comm-product-details="$emit('comm-product-details', $event)" /> -->
        <!-- @comm-product-details="handleTest($event)" /> -->
        <!-- v-on="$listeners" /> -->
    </div>
  </div>
  <div v-else-if="formData.layout === layouts.single">
    <!-- <div class="row">
      <div class="post col-md-8">
      </div>
    </div> -->
    <comm-product
      :contentKey="commProductList[formData.selectedIndex].key"
      :cmptData="commProductList[formData.selectedIndex]"
      addBtnConfetti />
      <div class="d-flex justify-content-between align-items-stretch flex-column flex-md-row">
        <div @click="handleBack()" class="d-flex align-items-center">
          <div class="icon prev">
            <!-- <i class="mdi mdi-chevron-triple-left"></i> -->
            <b-icon icon="chevron-double-left"></b-icon>
          </div>
          <div class="text" style="cursor: pointer;">
            <strong class="text-primary">Zurück</strong>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import { json2Html } from '@/service/utils/ProsemirrorConverter'
import * as htmlUtil from '@/service/utils/html'
import * as events from '@/events'
import * as seoUtil from '@/service/utils/seo'
import CommProduct from '@/components/glcwc-content/CommProduct.vue'

// TODO: externalize error messages!
const CONFIG_ERROR = 'Error in component configuration!',
  SERVER_API_ERROR = 'Error calling the server API!',
  ADD_BTN_CLASS = 'btn btn-success',
  ADD_BTN_CONFETTI_CLASS = 'btn-confetti',
  LAYOUT_SINGLE = 'single',
  LAYOUT_LIST = 'list',
  LAYOUT_TABLE = 'table'

export default {
  name: 'comm-prod-list',
  version: '0.0.5',
  props: {
    instKey: {
      type: String,
      required: true
    },
    cpKeyListFilter: {
      type: String,
      required: false
    },
    tagListFilter: {
      type: String,
      required: false
    },
    selectedIndex: {
      type: Number,
      default: 0
    },
    genSeo: {
      type: Boolean,
      default: false
    },
    addBtnConfetti: {
      type: Boolean,
      default: false
    },
    layout: {
      type: String,
      default: LAYOUT_LIST,
      validator: function (value) {
        return [LAYOUT_SINGLE, LAYOUT_LIST, LAYOUT_TABLE].indexOf(value) !== -1
      }
    }
  },
  components: {
    CommProduct
  }, //components
  data () {
    return {
      layouts: {
        single: LAYOUT_SINGLE,
        list: LAYOUT_LIST,
        table: LAYOUT_TABLE
      }, // layouts
      loaded: false,
      info: '... loading content!',
      infoStyle: { 'text-align': 'left', color: 'black' },
      addBtnClass: this.addBtnConfetti ? ADD_BTN_CONFETTI_CLASS : ADD_BTN_CLASS,
      addBtnClassList: {},
      commProductList: [],
      formData: {
        layout: LAYOUT_LIST,
        selectedIndex: 0
      }
    }
  }, // data
  /* ----- vuejs hooks ----- */
  async mounted() {
    console.log('TRACE-REMOVE: CommProdList.mounted: this.addBtnClass is: ', this.addBtnClass)
    if ((!this.instKey) || (!this.cpKeyListFilter && !this.tagListFilter)) {
      this.info = CONFIG_ERROR
      this.infoStyle.color = 'red'
    } else {
      try {
        const _resp = await axios.get(config.glapiBaseUri + '/content/' + this.instKey +
          '/keyListFilter/' + this.cpKeyListFilter)
        if (_resp.data && _resp.data.status === 'success') {
          this.commProductList = _resp.data.payload.content
          this.formData.layout = this.layout
          this.formData.selectedIndex = this.selectedIndex
          console.log('TRACE-REMOVE: CommProdList.mounted: this.genSeo is: ', this.genSeo)
          var itemList = null
          if (this.genSeo) {
            itemList = seoUtil.DEFAULT_ITEM_LIST()
            var position = 0
            for (let cp of this.commProductList) {
              this.$set(this.addBtnClassList, cp.key, this.addBtnClass)
              const listItem = seoUtil.DEFAULT_LIST_ITEM()
              listItem.position = ++position
              listItem.item = seoUtil.DEFAULT_PRODUCT_ITEM()
              listItem.item.url = window.location.href + '/' + cp.key
              listItem.item['@id'] = window.location.href + '/' + cp.key
              listItem.item.name = cp.fragments.title
              listItem.item.description = this.json2Html(cp.fragments.descr).replace(/<[^>]*>/g, '')
              listItem.item.image = cp.fragments.imgSrc
              listItem.item.offers = seoUtil.DEFAULT_OFFERS_ITEM()
              if (cp.fragments.available) {
                listItem.item.offers.availability = seoUtil.ITEM_AVAILABILITY_IN_STOCK
              } else {
                listItem.item.offers.availability = seoUtil.ITEM_AVAILABILITY_SOLD_OUT
              }
              listItem.item.offers.price = cp.fragments.price
              listItem.item.offers.priceCurrency = cp.fragments.currency
              listItem.item.offers.url = window.location.href + '/' + cp.key
              itemList.itemListElement.push(listItem)
            }
          }
          console.log('TRACE-REMOVE: CommProdList.mounted: itemList is: ', itemList)
          htmlUtil.addJsonldToHead(itemList ? JSON.stringify(itemList) : null)
          this.loaded = true
        } else {
          throw SERVER_API_ERROR
        }
      } catch (e) {
        console.error('ERROR-REMOVE: CommProdList.mounted: exception is: ', e)
        this.info = SERVER_API_ERROR
        this.infoStyle.color = 'red'
      }
    }
  }, // mounted
  methods: {
    json2Html,
    handleBack () {
      console.log('TRACE-REMOVE: CommProdList.handleBack!')
      this.formData.layout = LAYOUT_LIST
      this.formData.selectedIndex = 0
      this.$emit('comm-product-details')
    }, // handleBack
    handleDetails(e) {
      this.formData.layout = LAYOUT_SINGLE
      this.formData.selectedIndex = this.commProductList.findIndex(prod => prod.key === e)
      this.$emit('comm-product-details', e)
    }, // handleDetails
    handleAdd2Basket (key) {
      events.bus.emitGlobal(events.types.orders.GLGE_ADD_2_BASKET,
        { commProduct: key, amount: 1 })
      this.$set(this.addBtnClassList, key, this.addBtnClass + ' animate')
      setTimeout(() => {
        this.$set(this.addBtnClassList, key, this.addBtnClass)
      }, 700)
    } // handleAdd2Basket
  } // methods
}
</script>

<style scoped>
/* @import '~@mdi/font/css/materialdesignicons.min.css'; */
@import '~bootstrap/dist/css/bootstrap.css';
@import '~@/assets/css/buttons.css';
</style>
